module.exports = __webpack_public_path__ + "static/img/inreview.1aa1c57e.png";